import { NgModule } from "@angular/core";
import { SettingsRoutingModule } from "./settings-routing.module";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { FunctionsService } from "../../services/functions.service";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerModule } from "ngx-spinner";
import { BreadcrumbModule } from "xng-breadcrumb";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSortModule } from "@angular/material/sort";
import { NgxPermissionsModule } from "ngx-permissions";
import { SettingsComponent } from "./settings.component";
import { EmailNotificationsComponent } from "./email-notifications/email-notifications.component";
import { NotificationApproversComponent } from "./notification-approvers/notification-approvers.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { SharedModule } from "src/app/shared/shared.module";
import { AgentsInFieldComponent } from "./agents-in-field/agents-in-field.component";
import { TimeConfigurationComponent } from "./time-configuration/time-configuration.component";
import { AgentDispatchConfigurationComponent } from "./agent-dispatch-configuration/agent-dispatch-configuration.component";
import { EditGroupComponent } from "./group-management/edit-group/edit-group.component";
import { AuthInterceptorProvider } from "src/app/services/token/token-interceptor.service";

@NgModule({
    declarations: [
        EditGroupComponent,
        EmailNotificationsComponent,
        NotificationApproversComponent,
        AgentsInFieldComponent,
        TimeConfigurationComponent,
        AgentDispatchConfigurationComponent,
        SettingsComponent
    ],
    imports: [
        SettingsRoutingModule,
        BreadcrumbModule,
        CommonModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatTableModule,
        MatTabsModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
        MatSortModule,
        NgbModule,
        NgxPermissionsModule,
        NgxSpinnerModule,
        ReactiveFormsModule,
        TranslateModule,
        SharedModule,
    ],
    providers: [FunctionsService, AuthInterceptorProvider]
})
export class SettingsModule { }